// extracted by mini-css-extract-plugin
module.exports = {"Container":"spinner_Container__2keA2","Spinner":"spinner_Spinner__3vQdt","spinner":"spinner_spinner__2AyWI"};